import { mapGetters, mapActions } from 'vuex'
import { metaInfoBuilder, kebabToSnake } from '../utilities'
import { PAGES, BLOCKS } from '../content-types'
const type = PAGES.SERVICE

export const ServiceComponent = {
  name: 'ServiceComponent',
  computed: {
    ...mapGetters('prismic', ['getPage', 'getBlock', 'getAlternateLanguages']),
    service() {
      return this.page ? {
        main: this.page.main,
        content: this.page.content
          .map(component => {
            const block = this.centralizedBlocks.find(b => component.component === kebabToSnake(b))
            return this.getBlock(block) || component
          })
      } : { main: null, content: [] }
    },
  },
  methods: {
    ...mapActions('prismic', ['setPage', 'setBlock'])
  },
  async serverPrefetch() {
    const blocks = this.centralizedBlocks
      .map(uid => this.setBlock(uid))
    const page = this.setPage({ uid: this.$route.params.uid, type })
    await Promise
      .all([...blocks, page])
      .then(() => this.page = this.getPage({ uid: this.$route.params.uid, type }))
  },
  created() {
    const blocks = this.centralizedBlocks
      .map(uid => this.setBlock(uid))
    const page = this.setPage({ uid: this.$route.params.uid, type })
    Promise
      .all([...blocks, page])
      .then(() => this.page = this.getPage({ uid: this.$route.params.uid, type }))
  },
  metaInfo() {
    const page = this.page
    return page ? metaInfoBuilder(page, this.$route, this.getAlternateLanguages({type, uid: this.$route.params.uid})) : {}
  },
  data() {
    return {
      page: null,
      centralizedBlocks: []
    }
  }
}
